var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"navbar-item",on:{"click":_vm.onSelectBranchOffice}},[_c('b-icon',{attrs:{"icon":"building"}}),_c('span',[_vm._v(_vm._s(_vm.branchOffice))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }